import { render, staticRenderFns } from "./cartPage.vue?vue&type=template&id=91374784&"
import script from "./cartPage.vue.ts?vue&type=script&lang=ts&"
export * from "./cartPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports